import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getWrappedCardStyles } from '../styles';

export const WrappedCard = ({
  colNumber,
  minOccupiedColNumber,
  defaultColMinWidth,
  isAutoFillBlankDisabled,
  occupiedColNumber,
  minWidth,
  name,
  children,
}) => {
  const classes = useDefaultStyles(getWrappedCardStyles, {
    widthPercentage: occupiedColNumber / colNumber,
    // normalize flex-grow, to make sure it is >= 1
    flexGrow: !isAutoFillBlankDisabled && occupiedColNumber / minOccupiedColNumber,
    minWidth: minWidth || occupiedColNumber * defaultColMinWidth,
  });

  return (
    <div className={classNames('card-wrapper', classes.cardWrapper)} data-name={name}>
      {children}
    </div>
  );
};

WrappedCard.propTypes = {
  colNumber: PropTypes.number.isRequired,
  minOccupiedColNumber: PropTypes.number.isRequired,
  defaultColMinWidth: PropTypes.number.isRequired,
  isAutoFillBlankDisabled: PropTypes.bool.isRequired,
  occupiedColNumber: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  minWidth: PropTypes.number,
  children: PropTypes.node,
};

WrappedCard.defaultProps = {
  minWidth: NaN,
  children: null,
};
